import { Link } from "react-router-dom";
import { Target, Compass, Heart, Trophy, Users, Sparkles } from "lucide-react";
import PageHeader from "../components/site/PageHeader";
import { CLUB_PRESIDENT, CLUB_LOCATION, CLUB_FOUNDED } from "../lib/api";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        eyebrow="Hakkımızda"
        title="Çok Branşlı, Hedef Odaklı Kulüp"
        subtitle="Focus Spor Kulübü; çocuklara, gençlere ve yetişkinlere güvenli, disiplinli ve kaliteli bir spor ortamı sunan, gelişim odaklı bir kulüp yapısıdır."
      />

      <section className="section-pad">
        <div className="container-x grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7 space-y-5 text-base md:text-lg leading-relaxed text-muted-foreground">
            <p>
              <span className="text-foreground font-semibold">Focus Spor Kulübü (FCS)</span>; {CLUB_LOCATION}
              merkezli, {CLUB_FOUNDED} yılında kurulmuş çok branşlı bir spor kulübüdür. 20'yi aşkın branşı tek
              çatı altında buluşturarak; her yaş grubuna profesyonel eğitim, gelişim ve organizasyon imkânı
              sunuyoruz.
            </p>
            <p>
              Kulüp Başkanımız <span className="text-foreground font-semibold">{CLUB_PRESIDENT}</span>'un
              liderliğinde, alanında uzman antrenörler ve sporcu adayları ile sürdürülebilir bir kulüp kültürü
              oluşturuyor; sportif başarıyı yalnızca kazanmak değil, doğru disiplini içselleştirmek olarak
              tanımlıyoruz.
            </p>
            <p>
              Genç sporcular için bilimsel atletik performans programları, çocuklar için temel motor gelişim
              kursları ve yetişkinler için kondisyon, pilates ve dövüş sanatları eğitimleri sunarak,
              Tuzla'nın spor merkezlerinden biri olmayı hedefliyoruz.
            </p>
          </div>
          <aside className="lg:col-span-5 space-y-4">
            <FactCard icon={Compass} title="Misyon" body="Çocuklara, gençlere ve yetişkinlere güvenli, disiplinli ve kaliteli bir spor ortamı sunmak." />
            <FactCard icon={Target} title="Vizyon" body="Tuzla'dan başlayarak farklı branşlarda güçlü sporcular, bilinçli aileler ve sürdürülebilir bir kulüp kültürü oluşturmak." />
          </aside>
        </div>
      </section>

      <section className="section-pad border-t border-border bg-[hsl(218_55%_5%)]">
        <div className="container-x">
          <div className="eyebrow mb-3">Değerlerimiz</div>
          <h2 className="heading-lg max-w-3xl">İlkelerle <span className="text-primary">çalışıyoruz</span></h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {VALUES.map((v) => (
              <div key={v.title} className="card-elev p-6">
                <div className="h-11 w-11 rounded-md bg-primary/10 ring-1 ring-primary/20 flex items-center justify-center text-primary mb-3">
                  <v.icon className="h-5 w-5" />
                </div>
                <h3 className="font-display text-xl font-bold uppercase tracking-tight">{v.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-x text-center max-w-2xl mx-auto">
          <div className="eyebrow mb-3 justify-center">Kulübe Katıl</div>
          <h2 className="heading-lg">Sen de Focus ailesinin parçası ol.</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Branşlarımızı incele, bir etkinliğe kayıt ol ya da antrenör olarak başvur — Focus Spor Kulübü kapısı sana açık.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link to="/branslar" className="btn-primary" data-testid="about-cta-branches">Branşları İncele</Link>
            <Link to="/iletisim" className="btn-secondary" data-testid="about-cta-contact">İletişime Geç</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

const VALUES = [
  { icon: Target, title: "Odaklanma", text: "Hedefe götüren tek yol: dağılmadan, doğru tekniğe odaklanmak." },
  { icon: Heart, title: "Disiplin", text: "Sürekli, ölçülebilir ve sürdürülebilir gelişim için disiplin esastır." },
  { icon: Users, title: "Topluluk", text: "Sporcular, aileler ve antrenörlerin oluşturduğu güçlü bir aile yapısı." },
  { icon: Trophy, title: "Başarı", text: "Sahada başarı, hayatta karakter — ikisini birden büyütüyoruz." },
  { icon: Sparkles, title: "Kalite", text: "Kalifiye eğitmenler, modern ekipman ve bilimsel program." },
  { icon: Compass, title: "Yol Göstericilik", text: "Sporcunun ihtiyacına göre kişiselleştirilmiş gelişim planı." },
];

function FactCard({ icon: Icon, title, body }) {
  return (
    <div className="card-elev p-6">
      <div className="flex items-center gap-3 mb-3">
        <div className="h-10 w-10 rounded-md bg-primary/10 ring-1 ring-primary/20 flex items-center justify-center text-primary">
          <Icon className="h-5 w-5" />
        </div>
        <h3 className="font-display text-2xl font-bold uppercase tracking-tight">{title}</h3>
      </div>
      <p className="text-muted-foreground leading-relaxed">{body}</p>
    </div>
  );
}
